import { Tooltip } from 'antd'
import moment from 'moment'
import { isArray } from 'lodash'

import { EUROPEAN_DATE, EUROPEAN_DATE_WITH_HOURS_AND_MINUTES, HOURS_AND_MINUTES } from '../../../utils/constants'
import ChatMessageFile from './ChatMessageFile'

const ChatMessage = ({ files, message, timestamp, received, username }) => {
  const now = moment()
  const time = moment(timestamp)

  const displayedTime = time.isSameOrAfter(now, 'day') ? time.format(HOURS_AND_MINUTES) : time.format(EUROPEAN_DATE)

  return (
    <div className={'message ' + (received ? 'received' : 'sent')}>
      <Tooltip title={time.format(EUROPEAN_DATE_WITH_HOURS_AND_MINUTES)} placement='right'>
        <div className='text-bubble'>
          <div className='user-and-time'> <b>{username}</b> - {displayedTime}</div>
          <div className='text'>{message}</div>
        </div>
      </Tooltip>
      {isArray(files) && files.map(file => (
        <ChatMessageFile key={file.id} file={file} received={received} />
      ))}
    </div>
  )
}

export default ChatMessage
